// Per-version context every unit card reads: inline stats, checks, comments
// and the callbacks that keep the editor page's copy of them current.

import { createContext, useContext } from "react";
import type { ContentCheck, TalkTrackComment, UnitStats } from "../../types/talkTrack";

export interface UnitContextValue {
  topicId: string;
  version: number;
  editable: boolean;
  statsByUnit: Map<string, UnitStats>;
  checksByUnit: Map<string, ContentCheck[]>;
  commentsByUnit: Map<string, TalkTrackComment[]>;
  // The unit the page last scrolled to (briefly highlighted).
  focusedUnit: string | null;
  onComment: (comment: TalkTrackComment) => void;
  onError: (message: string) => void;
}

export const UnitContext = createContext<UnitContextValue | null>(null);

export function useUnitContext(): UnitContextValue {
  const ctx = useContext(UnitContext);
  if (!ctx) throw new Error("useUnitContext must be used inside a UnitContext provider");
  return ctx;
}
